import { render, staticRenderFns } from "./InstallationActions.vue?vue&type=template&id=354f9df9&scoped=true"
import script from "./InstallationActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstallationActions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InstallationActions.vue?vue&type=style&index=0&id=354f9df9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f9df9",
  null
  
)

export default component.exports